import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

const SaveJamesManifesto = () => {
  return (
    <div className="bg-dark text-white" style={{ minHeight: "100vh" }}>
      <Container className="py-5">
        {/* Header Section */}
        <Row className="text-center mb-5">
          <Col>
            <h1 className="display-3 text-white mb-3">$SAVEJAMES Manifesto</h1>
            <p className="lead">
              Doing well by doing good. A movement for a brighter future.
            </p>
          </Col>
        </Row>

        {/* Doing Well by Doing Good */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-white mb-3">
              Doing Well by Doing Good
            </h2>
            <p className="text-center">
              Welcome to $SAVEJAMES, where purpose meets prosperity. Doing good
              for the world aligns with doing well for yourself.
            </p>
          </Col>
        </Row>

        {/* Crisis We Must Address */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-white mb-3">
              A Crisis We Must Address
            </h2>
            <p className="text-center">
              Untold children are subjected to irreversible medical
              interventions that harm their bodies and futures. These
              procedures, often driven by ideology, exploit the most vulnerable
              among us.
            </p>
            <p className="text-center mb-5">
              $SAVEJAMES believes this must stop. But we're not just about
              opposition, we're about solutions. We aim to create a world where
              children can thrive without being forced into destructive paths by
              exposing injustices and empowering communities with resources.
            </p>
          </Col>
        </Row>

        {/* Empowering Change - Coin Section */}
        <Row className="mb-5">
          <Col md={12}>
            <Card className="bg-white text-dark">
              <Card.Body>
                <Card.Title className="text-center display-4 text-warning">
                  The $SAVEJAMES Coin: Empowering Change
                </Card.Title>
                <Card.Text className="text-center">
                  The $SAVEJAMES movement coin isn't just a token—it's a tool
                  for change. It allows people to take a stand while building
                  financial opportunity. Every transaction fuels advocacy
                  efforts, legal defenses, and public awareness campaigns.
                  <br />
                  As the movement grows, so does the social impact and the value
                  of our coin.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Why is this different? */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-white mb-3">
              Why is this different?
            </h2>
            <ul className="list-unstyled text-center text-white">
              <li>
                <strong>Aligning Values and Incentives:</strong> When you invest
                in $SAVEJAMES, you're contributing to a cause while creating
                value for yourself and the community.
              </li>
              <li>
                <strong>Transparency Built In:</strong> Blockchain technology
                ensures every contribution is traceable, accountable, and
                impactful.
              </li>
              <li>
                <strong>Global Access:</strong> The $SAVEJAMES coin is for
                everyone, everywhere. Borders don't limit the fight for
                children's futures.
              </li>
            </ul>
          </Col>
        </Row>

        {/* How You Can Do Well by Doing Good */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-white mb-4">
              How You Can Do Well by Doing Good
            </h2>
            <ol className="text-center text-white">
              <li>
                Invest in $SAVEJAMES Coin - Your support helps end harmful
                practices and protects children, all while building a
                movement-driven asset.
              </li>
              <li>
                Share the Mission - Every new voice amplifies our impact. Use
                social media, conversations, and online platforms to spread the
                word.
              </li>
              <li>
                Fund Local Heroes - When $SAVEJAMES does well, grassroots
                activist efforts do well, ensuring resources reach where they're
                needed most.
              </li>
            </ol>
          </Col>
        </Row>

        {/* A Win-Win Future */}
        <Row className="bg-dark text-white py-5 mb-5">
          <Col md={12}>
            <h2 className="text-center mb-4">A Win-Win Future</h2>
            <p className="text-center">
              Imagine being part of a movement that safeguards children's
              futures while building financial empowerment for its supporters.
              This isn't just a dream—it's a reality we're creating together.
            </p>
            <p className="text-center mb-5">
              Together, we can show the world what it means to thrive by helping
              others succeed.
            </p>
          </Col>
        </Row>

        {/* Call to Action Section */}
        <Row className="mb-5">
          <Col md={12}>
            <h2 className="text-center text-white mb-4">Take Action Today</h2>
            <p className="text-center text-white">
              Invest in{" "}
              <a
                href="https://dexscreener.com/solana/enyvkesxxfeoy8wgpf9hedh7qnfbcxwo9awt3kjk8fyw"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
                className="text-white"
              >
                <p className="hvr-buzz-out mb-0">$SAVEJAMES</p>
              </a>
              . Grow the movement. Grow your impact. Grow your future.
            </p>
            <h3 className="text-center text-warning mb-4">
              $SAVEJAMES: A brighter future—for children, for you, for us all.
            </h3>
          </Col>
        </Row>

        {/* Footer Call to Action */}
        <Row className="text-center mb-5">
          <Col>
            <Button
              variant="primary"
              size="lg"
              href="https://dexscreener.com/solana/enyvkesxxfeoy8wgpf9hedh7qnfbcxwo9awt3kjk8fyw"
              target="_blank"
            >
              Join the Movement
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SaveJamesManifesto;
